(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll("[data-choose-flavor]"));
  if (!roots.length) return;

  function shopifyRoot() {
    return window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
  }

  function initChooseFlavor(root) {
    var flavors = root.querySelectorAll("[data-flavor]");
    var priceEl = root.querySelector("[data-sub-price]");
    var compareEl = root.querySelector("[data-compare-price]");
    var badgeEl = root.querySelector("[data-save-badge]");
    var submitBtn = root.querySelector("[data-choose-flavor-submit]");
    var moneyFormat = root.getAttribute("data-money-format") || "{{amount}}";
    var saveLabel = root.getAttribute("data-save-label") || "SAVE [percent]%";
    var busy = false;

    function formatMoney(cents) {
      var value = Number(cents) || 0;
      var format = moneyFormat || "{{amount}}";
      var formatted = "";

      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        formatted = Shopify.formatMoney(value, format);
      } else {
        var amount = (value / 100).toFixed(2);
        var amountNoDecimals = String(Math.round(value / 100));

        formatted = format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      if (value % 100 === 0) {
        formatted = formatted.replace(".00", "").replace(",00", "");
      }

      return formatted;
    }

    function getSelectedItems() {
      var items = [];

      flavors.forEach(function (flavor) {
        var check = flavor.querySelector("[data-flavor-check]");
        var qtyEl = flavor.querySelector("[data-qty-value]");
        var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
        if (!check || !check.checked || qty < 1) return;
        if (flavor.getAttribute("data-available") === "false") return;

        items.push({
          flavor: flavor,
          variantId: parseInt(flavor.getAttribute("data-variant-id"), 10),
          quantity: qty,
          priceCents: parseInt(flavor.getAttribute("data-price-cents"), 10) || 0,
          compareAtCents: parseInt(flavor.getAttribute("data-compare-at-cents"), 10) || 0,
        });
      });

      return items;
    }

    function updatePrices() {
      var items = getSelectedItems();
      var compare = 0;
      var current = 0;

      items.forEach(function (item) {
        current += item.priceCents * item.quantity;
        compare +=
          (item.compareAtCents > item.priceCents ? item.compareAtCents : item.priceCents) *
          item.quantity;
      });

      if (priceEl) priceEl.textContent = formatMoney(current);

      if (compareEl) {
        compareEl.textContent = formatMoney(compare);
        compareEl.hidden = !compare || current >= compare;
      }

      if (badgeEl) {
        var percent = 0;
        if (compare > 0 && current < compare) {
          percent = Math.round(((compare - current) * 100) / compare);
        }

        if (percent > 0) {
          badgeEl.hidden = false;
          badgeEl.textContent = saveLabel.replace("[percent]", String(percent));
        } else {
          badgeEl.hidden = true;
          badgeEl.textContent = "";
        }
      }

      if (submitBtn) {
        var disabled = items.length === 0 || busy;
        submitBtn.disabled = disabled;
        submitBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
      }
    }

    function setFlavorState(flavor, checked, qty) {
      var check = flavor.querySelector("[data-flavor-check]");
      var qtyEl = flavor.querySelector("[data-qty-value]");
      if (check) check.checked = checked;
      if (qtyEl) qtyEl.textContent = String(qty);
    }

    flavors.forEach(function (flavor) {
      var check = flavor.querySelector("[data-flavor-check]");
      var qtyEl = flavor.querySelector("[data-qty-value]");
      var minus = flavor.querySelector("[data-qty-minus]");
      var plus = flavor.querySelector("[data-qty-plus]");

      if (!check || flavor.getAttribute("data-available") === "false") {
        return;
      }

      flavor.addEventListener("click", function (event) {
        if (
          event.target.closest("[data-qty-minus]") ||
          event.target.closest("[data-qty-plus]") ||
          event.target.closest(".choose-flavor__qty") ||
          event.target.closest(".choose-flavor__check") ||
          event.target === check
        ) {
          return;
        }

        check.checked = !check.checked;
        check.dispatchEvent(new Event("change", { bubbles: true }));
      });

      check.addEventListener("change", function () {
        var qty = parseInt(qtyEl.textContent, 10) || 0;

        if (check.checked && qty === 0) {
          setFlavorState(flavor, true, 1);
        } else if (!check.checked) {
          setFlavorState(flavor, false, 0);
        }

        updatePrices();
      });

      if (minus) {
        minus.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var qty = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) - 1);
          setFlavorState(flavor, qty > 0, qty);
          updatePrices();
        });
      }

      if (plus) {
        plus.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var qty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
          setFlavorState(flavor, true, qty);
          updatePrices();
        });
      }
    });

    if (submitBtn) {
      submitBtn.addEventListener("click", function () {
        if (busy) return;

        var selected = getSelectedItems();
        if (selected.length === 0) return;

        // One-time add to cart only — never send selling_plan.
        var items = selected
          .filter(function (item) {
            return item.variantId;
          })
          .map(function (item) {
            return {
              id: item.variantId,
              quantity: item.quantity,
            };
          });

        if (!items.length) return;

        busy = true;
        submitBtn.disabled = true;

        fetch(shopifyRoot() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Add to cart failed");
            return res.json();
          })
          .then(function () {
            if (window.CpCartDrawer && typeof window.CpCartDrawer.openAfterAdd === "function") {
              return window.CpCartDrawer.openAfterAdd();
            }

            var openTrigger = document.querySelector("[data-cart-drawer-open]");
            if (openTrigger) {
              openTrigger.click();
              return;
            }
            window.location.href = shopifyRoot() + "cart";
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            busy = false;
            updatePrices();
          });
      });
    }

    updatePrices();
  }

  roots.forEach(initChooseFlavor);
})();
